import getConfig from "next/config";
import { hasWindow } from "@litres/utils";
import { determineApiUrlBasedOnTLD } from "../utils/determineApiUrlBasedOnTLD";

export const PORT =
  hasWindow && window.location.port ? window.location.port : 3000;

export const CATALYT_API_ORIGIN = hasWindow ? window.location.origin : ``;

export const CATALYT_BASE_URL =
  process.env.NODE_ENV === "test" || process.env.NODE_ENV === "development"
    ? `http://localhost${PORT ? `:${PORT}` : ""}`
    : CATALYT_API_ORIGIN;

export interface IAPIConfig {
  baseURL: string;
  SID: string;
}

type APIServiceName = "foundation" | "advertising" | "orders" | "tracker";

export const getBaseAPIUrl = (apiServiceName?: APIServiceName): string => {
  if (process.env.APP_ENV === "storybook" && process.env.API_URL) {
    return apiServiceName
      ? `${process.env.API_URL}/${apiServiceName}`
      : process.env.API_URL;
  }

  if (
    hasWindow &&
    (window.location.hostname === "www.fbhub.ru" ||
      window.location.hostname === "pda.fbhub.ru")
  ) {
    return apiServiceName
      ? `http://master.api.b.litres.ru/${apiServiceName}`
      : "http://master.api.b.litres.ru";
  }

  /**
   * Берем либо из энва apiUrl, либо проваливаемся дальше и берем от TLD
   */
  if (getConfig) {
    const config = getConfig();
    if (config?.publicRuntimeConfig?.apiUrl) {
      return apiServiceName
        ? `${config.publicRuntimeConfig.apiUrl as string}/${apiServiceName}`
        : (config.publicRuntimeConfig.apiUrl as string);
    }
  }

  if (hasWindow) {
    return apiServiceName
      ? `${determineApiUrlBasedOnTLD(
          window.location.hostname
        )}/${apiServiceName}`
      : determineApiUrlBasedOnTLD(window.location.hostname);
  }
  // старый стек:
  return apiServiceName
    ? `https://api.litres.ru/${apiServiceName}`
    : "https://api.litres.ru";
};
